"use client"

import * as React from "react"
import * as PopoverPrimitive from "@radix-ui/react-popover"

import { cn } from "@productlane/lib/src/browser"

export const InternalPopover = PopoverPrimitive.Root
export const InternalPopoverTrigger = PopoverPrimitive.Trigger
export const InternalPopoverAnchor = PopoverPrimitive.Anchor
export const InternalPopoverPortal = PopoverPrimitive.Portal

export const InternalPopoverContent = React.forwardRef<
	React.ElementRef<typeof PopoverPrimitive.Content>,
	React.ComponentPropsWithoutRef<typeof PopoverPrimitive.Content>
>(({ style, className, align = "center", sideOffset = 4, ...props }, ref) => (
	<PopoverPrimitive.Content
		ref={ref}
		align={align}
		sideOffset={sideOffset}
		style={{
			...style,
			maxHeight: "var(--radix-popover-content-available-height)",
		}}
		className={cn(
			"z-50 w-72 overflow-y-auto rounded-lg border border-gray-200 bg-gray-25 p-4 text-primary shadow-lg outline-none !duration-150 ease-out-cubic data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out data-[state=open]:fade-in data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2 dark:border-gray-700/70 dark:bg-gray-850",
			className,
		)}
		{...props}
	/>
))
